webpackJsonp([71778760475052],{

/***/ 161:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.RequestTrialTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// import Form from '../components/FormSimpleAjax'
	
	
	__webpack_require__(161);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(69);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(24);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var RequestTrialTemplate = exports.RequestTrialTemplate = function RequestTrialTemplate(_ref) {
	    var title = _ref.title,
	        image = _ref.image,
	        contactTitle = _ref.contactTitle,
	        contactContent = _ref.contactContent;
	
	
	    return _react2.default.createElement(
	        'main',
	        { className: 'contact-page' },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Assetlogue \u2013 Request a Trial'
	            )
	        ),
	        image && _react2.default.createElement('div', { className: 'banner-image', style: { backgroundImage: 'url(' + image.publicURL + ')' } }),
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            title && _react2.default.createElement(
	                'h1',
	                null,
	                title
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'contact-container' },
	                _react2.default.createElement('iframe', { src: 'https://pipedrivewebforms.com/form/a8254ac1411da4c79e349961da16917a3343926' }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    contactTitle && _react2.default.createElement(
	                        'h2',
	                        null,
	                        contactTitle
	                    ),
	                    contactContent && _react2.default.createElement(_Content2.default, { src: contactContent })
	                )
	            )
	        )
	    );
	};
	
	// Export Default HomePage for front-end
	var RequestTrialPage = function RequestTrialPage(_ref2) {
	    var _ref2$data = _ref2.data,
	        page = _ref2$data.page,
	        settingsYaml = _ref2$data.settingsYaml;
	    return _react2.default.createElement(RequestTrialTemplate, _extends({}, page, page.frontmatter, settingsYaml, { body: page.html }));
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = RequestTrialPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-request-trial-page-js-5984aa55a6ad1d941c6b.js